import { render, staticRenderFns } from "./AboutGenericBallot.vue?vue&type=template&id=4f0ac318&"
import script from "./AboutGenericBallot.vue?vue&type=script&lang=js&"
export * from "./AboutGenericBallot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports